import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";

export const requestGetSpaceTypes = async () => {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/ListaTipoEspacio", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.listaTipoEspacios.map(({ idTipoEspacio, tipoEspacio }) => ({
        id: idTipoEspacio,
        name: tipoEspacio
    }));
}

export async function requestGetUniversityActivities() {
    const [result, err] = await doRequest(
		"/EspacioUniversitario/ActividadesDisponibles", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data
		.listaActividades
        .map(({ idActividad, nombre, esDeportiva }) => ({
            id: idActividad, 
			name: nombre,
			isSport: esDeportiva
        }));
}

export async function requestGetUniversitySpaceReasonsForPenalize() {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/ListarMotivoSancion", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.listaMotivoSancion.map(({
        idMotivoSancion, nombre, descripcion, esPorDias
    }) => ({
        id: idMotivoSancion,
        name: nombre, 
        description: descripcion,
        isForDays: esPorDias
    }));
}